import { render, staticRenderFns } from "./JudgeMask.vue?vue&type=template&id=5f227e6e&scoped=true&"
import script from "./JudgeMask.vue?vue&type=script&lang=js&"
export * from "./JudgeMask.vue?vue&type=script&lang=js&"
import style0 from "./JudgeMask.vue?vue&type=style&index=0&id=5f227e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f227e6e",
  null
  
)

export default component.exports